function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.667 13.358A.667.667 0 010 12.691V10.31a.668.668 0 01.2-.472L9.355.684A2.319 2.319 0 0111 0a2.318 2.318 0 011.65.684 2.314 2.314 0 01.683 1.65 2.314 2.314 0 01-.683 1.65l-.981.981-.019.02-.019.018-8.16 8.16a.664.664 0 01-.471.2zm.667-2.772v1.438h1.391l7.512-7.511-1.414-1.415zm9.845-7.016l.528-.528A.994.994 0 0012 2.335a.994.994 0 00-.293-.707.991.991 0 00-.706-.292.993.993 0 00-.707.292l-.529.529z",
  fill: "#545454"
});

var SvgIconHensyuu = function SvgIconHensyuu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.333,
    height: 13.358
  }, props), _ref);
};

export default SvgIconHensyuu;